import React, {
  useEffect
} from 'react';

import {
  useAppDispatch
} from '../../hooks/useAppDispatch';
import {
  useAppSelector
} from '../../hooks/useAppSelector';

import {
  toggleVisibility
} from '../../store/drawer';

import MapPane from '../MapPane';

export type MainProps = React.ComponentProps<'div'>;

export const Main: React.FC<Partial<MainProps>> = ({
  ...passThroughProps
}): JSX.Element => {

  const isDrawerOpen = useAppSelector(state => state.drawer.visible);
  const activeTool = useAppSelector(state => state.activeTool);
  const activePane = useAppSelector(state => state.activePane);

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (activeTool && !isDrawerOpen) {
      dispatch(toggleVisibility());
    }
  }, [dispatch, activeTool, isDrawerOpen]);

  const getMainContent = () => {
    switch (activePane) {
      case 'map':
        return <MapPane />;
      default:
        break;
    }
  };

  return (
    <div
      className="main"
      {...passThroughProps}
    >
      {getMainContent()}
    </div>
  );
};

export default Main;
